import { Link } from 'react-router-dom'

import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../i18n/index.js'

import { MessagingSettings } from './Settings.js'

export const MessagingSidebarHeader = () => {
  return (
    <div className="flex flex-auto items-center gap-x-3">
      <div
        className="font-medium text-lg truncate text-content grow leading-10"
        translate="no"
      >
        <T defaultMessage="Chats" id="Generics.Chats" />
      </div>
      <MessagingSettings />
      <IconButton
        variant="secondaryNeutral"
        icon={<SvgIcon name="plus" className="text-content-subdued" />}
        className="border border-line-subdued rounded-base"
        as={Link}
        to="/messaging/new"
      />
    </div>
  )
}
